import { useRouter } from 'next/router'

import { Breadcrumb } from '@components/Breadcrumb'
import { AppRoutes } from '@constants/app-routes'

import { config } from './config'
import { BoxWrapper } from './styles'
import { BreadcrumbsProps } from './types'

const incorrectRoutes = [
  AppRoutes.home,
  AppRoutes.aboutUs,
  AppRoutes.adTech,
  AppRoutes.career,
  AppRoutes.partnership,
  AppRoutes.approach,
  AppRoutes.blog,
  AppRoutes.portfolio,
  AppRoutes.news,
  AppRoutes.augmentationVendor,
  AppRoutes.augmentationVendorThanks,
  AppRoutes.developYourProduct,
  AppRoutes.scaleYourTeam,
  AppRoutes.fintech,
  AppRoutes.enterprise,
  AppRoutes.medtech,
  AppRoutes.socialNetworking,
  AppRoutes.logistics,
  AppRoutes.travel,
  AppRoutes.iot,
  AppRoutes.mobileDevelopment,
  AppRoutes.frontend,
  AppRoutes.backend,
  AppRoutes.devOps,
  AppRoutes.monitoring,
  AppRoutes.healthcare,
  AppRoutes.privacyPolicy,
  AppRoutes.qualityAssurance,
  AppRoutes.businessAnalysisServices,
] as string[]

const DEFAULT_MARGIN_TOP = '16px'

const getLabelFromLink = (title: string) => {
  const result = config.find(item => item.from === title)
  if (result) {
    return result.to
  }
  return ''
}

export function Breadcrumbs({
  textColor,
  marginTop = DEFAULT_MARGIN_TOP,
}: BreadcrumbsProps) {
  const currentPath = useRouter().pathname

  return incorrectRoutes.includes(currentPath) ? null : (
    <BoxWrapper marginTop={marginTop} className="breadcrumbs">
      <Breadcrumb
        transformLabel={title => getLabelFromLink(title)}
        textColor={textColor}
      />
    </BoxWrapper>
  )
}
